import React from "react";

export default function AboutFeature() {
  return (
    <div className="container flex justify-center items-center mt-20">
      <div className="w-3/4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="col-span-1 text-center px-5 py-10 border-2 rounded-md">
            <div className="flex justify-center items-center">
              <div className="bg-green-900 rounded-full w-28">
                <img
                  src={require("../../images/testi-1.png")}
                  alt="Logo 1"
                  className="mx-auto w-28"
                />
              </div>
            </div>

            <h5 className="text-2xl mt-1 cursor-pointer md:hover:text-green-700 md:hover:font-bold">
              Corporate Services
            </h5>
            <p className="text-slate-400 mt-5">
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Voluptatibus iusto libero unde nesciunt vero modi eligendi tempora
              aliquam atque! Illo!
            </p>
          </div>

          <div className="col-span-1 text-center px-5 py-10 border-2 rounded-md">
            <div className="flex justify-center items-center">
              <div className="bg-green-900 rounded-full w-28">
                <img
                  src={require("../../images/testi-2.png")}
                  alt="Logo 1"
                  className="mx-auto w-28"
                />
              </div>
            </div>

            <h5 className="text-2xl mt-1 cursor-pointer md:hover:text-green-700 md:hover:font-bold">
              Corporate Pickup
            </h5>
            <p className="text-slate-400 mt-5">
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Voluptatibus iusto libero unde nesciunt vero modi eligendi tempora
              aliquam atque! Illo!
            </p>
          </div>

          <div className="col-span-1 text-center px-5 py-10 border-2 rounded-md">
            <div className="flex justify-center items-center">
              <div className="bg-green-900 rounded-full w-28">
                <img
                  src={require("../../images/testi-3.png")}
                  alt="Logo 1"
                  className="mx-auto w-28"
                />
              </div>
            </div>

            <h5 className="text-2xl mt-1 cursor-pointer md:hover:text-green-700 md:hover:font-bold">
              Corporate Events
            </h5>
            <p className="text-slate-400 mt-5">
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Voluptatibus iusto libero unde nesciunt vero modi eligendi tempora
              aliquam atque! Illo!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
